{
  "version": 1,
  "asset_id": "4595710c-e367-4944-9774-f3a452134add",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/4595710c-e367-4944-9774-f3a452134add/sleeve-fitzer-1-220.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/4595710c-e367-4944-9774-f3a452134add/sleeve-fitzer-1-220.png",
  "original_filename": "sleeve-fitzer-1-220.png",
  "size": 33451,
  "content_type": "image/png",
  "created_at": "2026-09-29T01:15:38Z"
}
